// extracted by mini-css-extract-plugin
export default {"preForm":"styles_preForm__TReXK","head":"styles_head__rGiNg"};